import React from 'react';
import { Select, message } from 'antd';
import { Translate, useTranslate } from '@above-the-treeline/localization';
import { useUserPreferences } from '../../../UserPreferences';

const { Option } = Select;

const EditRoleSummary = () => {
	const { translate } = useTranslate();
	const userPreferences = useUserPreferences();
	const {
		requestorType: roleOptionKey,
		requestorTypes: roleOptions,
	} = userPreferences.getReviewCopyDownloadPreferences();

	const SelectOneOptionKey = 'Select One';

	const getRoleOptionObjects = () => {
		let roleOptionsObjects = [];

		const selectOneOption = {
			key: SelectOneOptionKey,
			value: (
				<span className="select-one-option">
					{translate('select_one')}
				</span>
			),
		};

		roleOptionsObjects.push(selectOneOption);

		roleOptions.forEach(ro => {
			roleOptionsObjects.push({
				key: ro,
				value: <span>{ro}</span>,
			});
		});

		return roleOptionsObjects;
	};

	const getSelectedRoleOptionKey = roleOptionObjects => {
		const selectedRoleOptionObject = roleOptionObjects.find(
			roo => roo.key === roleOptionKey,
		);
		if (selectedRoleOptionObject) {
			return selectedRoleOptionObject.key;
		}
		return roleOptionObjects[0].key;
	};

	const onSelectChange = async roleOptionKey => {
		if (roleOptionKey === SelectOneOptionKey) {
			roleOptionKey = null;
		}

		const didSucceed = await userPreferences.saveRoleSummary(roleOptionKey);
		if (didSucceed) {
			return message.success(translate('role_summary_saved'));
		}
		return message.error(translate('error_saving_role_summary'));
	};

	const renderRoleOption = roleOptionObject => (
		<Option key={roleOptionObject.key}>{roleOptionObject.value}</Option>
	);

	const roleOptionObjects = getRoleOptionObjects();
	const selectedRoleOptionKey = getSelectedRoleOptionKey(roleOptionObjects);

	return (
		<div className="edit-role-summary">
			<div className="role-summary-label">
				<Translate id="role_summary" />:
			</div>
			<Select
				size="small"
				defaultValue={selectedRoleOptionKey}
				dropdownMatchSelectWidth={false}
				dropdownClassName="edit-role-summary-dropdown"
				onChange={onSelectChange}>
				{roleOptionObjects.map(renderRoleOption)}
			</Select>
		</div>
	);
};

export default EditRoleSummary;
